/**
 * Generates a random number between minimum and maximum range
 */
const randomNumberBetween = (min: number, max: number) =>
  Number.parseFloat((Math.random() * (max - min) + min).toFixed(1))

export default randomNumberBetween
